import axios from 'axios';
import store from '@root/store';
import router from '@root/router/index';


// Set config defaults when creating the instance
const admin = axios.create();

admin.defaults.baseURL = process.env.VUE_APP_API_URL;

// request interceptor.
admin.interceptors.request.use((request) => {
    const token = store.getters['admin/authToken'];

    if (token) {
        request.headers['Authorization'] = `Bearer ${token}`;
    }
    request.headers['Accept-Language'] = 'ar';
    return request;
});

// response interceptor
admin.interceptors.response.use(response => response, error => {

    const { status } = error.response;
    if (status >= 500) {
        alert(error.response);
    }

    if (status == 401) {
        router.push({ name: 'login' });
    }

    return Promise.reject(error)
});


export default admin;